import { Get } from "../../../../../Request";

export const GetData = async (limit = 15, page = null) => {
  return await Get({
    url: "/dashboard/user",
    data: {},
    page: page,
  }).then(data => {
    return data;
  });
};
export const dashboardManager = async (limit = 15, page = null) => {
  return await Get({
    url: "/dashboard/manager",
    data: {},
    page: page,
  }).then(data => {
    return data;
  });
};
export const payGhest = async data => {
 await Get({
    url: "/order/pay_contractual_reserve",
    data: data,
    stat: true,
  }).then(response => {
    if (response.data) {
      if (
        response.data &&
        response.data.url
      ) {
        window.location.replace(response.data.url);
      }
    }
  });
};
export const getOrderDetails = async request => {
  return await Get({
    url: "/order/order_details",
    data: request,
  }).then(data => {
    return data;
  });
};
